import React, { useCallback } from 'react'
import { Alert } from 'components'
import { useAlert } from 'components/Alerts/hooks'
import { alerts as alertKeys } from 'keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteAssessmentFetch } from 'store/middlewares/assessment.crud'
import { useSelector } from 'react-redux'
import { queryClient as qc } from 'keys'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'

const RemoveAssessmentAlert = (props) => {
    const { alerts } = useSelector(state => state.general)
    const { setAlerts } = useAlert()
    const queryClient = useQueryClient()

    const { mutateAsync: deleteAssessment } = useMutation({
        mutationFn: deleteAssessmentFetch,
        onSuccess: () => {
            handleClose()
            queryClient.invalidateQueries([qc.assessments])
        },
        onError: () => {
            handleClose()
            toast.error("בעייה במחיקה", toastConfig)
        }
    })

    const handleClose = useCallback(() => {
        setAlerts(alertKeys.removeAssessment, false)
    }, [])

    const removeAssessment = useCallback(() => {
        deleteAssessment(alerts.removeAssessment.props)
    }, [])

    const footerActions = React.useMemo(
        () => [
            { label: "ביטול", color: "thirdly4", action: handleClose },
            { label: "מחיקה", color: "error", action: removeAssessment }
        ], []
    )

    return (
        <Alert
            systemUI
            type="danger"
            title={" האם את בטוחה שאת רוצה למחוק את ההקצאה?"}
            footerActions={footerActions}
            handleAlert={handleClose}
        >
            {"מחיקת ההקצאה תמחק את המבדק לצמיתות"}
        </Alert>
    )
}

export default RemoveAssessmentAlert